module.exports = __webpack_public_path__ + "static/img-main-1ecf1e6e086ce49027ba1856165cd550.jpg";